import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Input } from '../../../components';
import { GeneralService, OrdersService } from '../../../services';
import { BackIcon, DoneIcon, FormTab1Icon, FormTab2ActiveIcon, FormTab2Icon } from '../../../assets/icons';
import { classNames, sanitizeToNumbers } from '../../../utils';
import SelectClient from './select-client';
import SelectRoute from './select-route';
import SelectDriver from './select-driver';
import SelectVehicle from './select-vehicle';

const STEP = {
  PERSONS: 1,
  ADDRESS: 2,
};

const ModalCreateOrder = ({ initialData, onClose, onSuccess }) => {
  const { form, isLoading, isEditingVehicle, nextStep, onChange, selects, setIsEditingVehicle, setStep, step } = useForm({ initialData, onClose, onSuccess });

  return (
    <div className="px-4 bg-white rounded-2xl shadow-xl overflow-hidden max-h-[90vh] w-[40rem] overflow-y-auto">
      <div className="flex items-center justify-between py-4">
        <h2 className="text-2xl font-bold text-black">Programar nuevo viaje</h2>
        <button
          type="button"
          className="p-1.5 rounded-full hover:bg-gray5 transition-colors"
          onClick={onClose}
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-text">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div className="flex justify-center items-center text-orange font-bold text-lg mb-4">
        <img src={FormTab1Icon} alt="Tab" className="w-6 h-6 object-contain mr-2" />
        <span>Datos</span>
        <hr className={classNames('w-8 mx-4', step === STEP.PERSONS ? 'border-orange' : 'border-gray6')} />
        <img
          className="w-6 h-6 object-contain mr-2"
          src={step === STEP.ADDRESS ? FormTab2ActiveIcon : FormTab2Icon}
          alt="Tab"
        />
        <span className={classNames(step === STEP.ADDRESS ? 'text-orange' : 'text-gray6')}>
          Dirección
        </span>
      </div>

      {step === STEP.PERSONS && (
        <div className="grid grid-cols-3 gap-x-2 gap-y-4">
          <div className="col-span-3">

            <p className="mb-1 text-text">Nombre del Cliente</p>
            <SelectClient
              value={form.user_id}
              selectedLabel={form.user?.company?.name}
              onSelect={item => {
                onChange('user_id', item?.id);
                onChange('user', item);
                onChange('name', item?.person?.name);
                onChange('phone', item?.person?.phone);
              }}
            />
          </div>

          <div>
            <p className="mb-1 text-text text-sm">CI o RIF</p>
            <div className="flex items-center border border-gray6 bg-white h-10 w-full rounded-full overflow-hidden">
              <select
                className="h-full bg-transparent outline-none text-sm px-4 border-r border-gray6"
                value={form?.user?.person?.company?.document_type || ''}
                onChange={e => onChange('document_type', e.target.value)}
                disabled
              >
                <option value=""></option>
                {selects.documentTypes.map(dt => (
                  <option key={dt.value} value={dt.value}>{dt.label}</option>
                ))}
              </select>
              <input
                type="text"
                className="flex-1 h-full outline-none border-none bg-transparent px-4 text-sm"
                value={form?.user?.person?.company?.document || ''}
                onChange={e => onChange('document', sanitizeToNumbers(e.target.value))}
                disabled
              />
            </div>
          </div>

          <Input
            type="date"
            label="Fecha del viaje"
            value={form.date}
            onValueChange={v => onChange('date', v)}
          />

          <Input
            type="time"
            label="Hora del viaje"
            value={form.time}
            onValueChange={v => onChange('time', v)}
          />

          <h3 className="col-span-3 text-xl font-semibold">
            Persona de contacto
          </h3>

          <Input
            label="Nombre"
            className={{ base: 'col-span-2' }}
            value={form.name}
            onValueChange={v => onChange('name', v)}
            placeholder="Nombre"
          />

          <Input
            label="Teléfono"
            value={form.phone}
            onValueChange={v => onChange('phone', v)}
            placeholder="Teléfono"
          />

          <Input
            label="Nombre"
            className={{ base: 'col-span-2' }}
            value={form.passenger.name}
            onValueChange={v => onChange('passenger.name', v)}
            placeholder="Nombre (Opcional)"
          />

          <Input
            label="Teléfono"
            value={form.passenger.phone}
            onValueChange={v => onChange('passenger.phone', v)}
            placeholder="Teléfono (Opcional)"
          />
        </div>
      )}

      {step === STEP.ADDRESS && (
        <div className="grid grid-cols-4 gap-x-2 gap-y-4 items-end">
          <button className="col-span-4" onClick={() => setStep(STEP.PERSONS)}>
            <img src={BackIcon} className="w-4 h-4 object-contain brightness-0" alt="Volver" />
          </button>

          <h3 className="col-span-3 text-xl font-semibold">
            Lugar de inicio
          </h3>

          <div className="col-span-4">
            <SelectRoute
              value={form.route_id}
              selectedLabel={form?.route?.name}
              onSelect={item => {
                onChange('route_id', item?.id);
                onChange('route', item);
              }}
            />
          </div>

          <h3 className="col-span-3 text-xl font-semibold">
            Asignar conductor
          </h3>

          <div className="col-span-2">
            <p className="mb-1 text-text">Nombre del Conductor</p>
            <SelectDriver
              value={form.driver_id}
              selectedLabel={form?.driver?.person?.fullName}
              onSelect={item => {
                onChange('driver_id', item?.id);
                onChange('driver', item);
                onChange('vehicle_id', item?.person?.driver?.vehicle_id);
                onChange('vehicle', item?.person?.driver?.vehicle);
              }}
            />
          </div>

          <div className="col-span-2 flex justify-between items-end gap-2">
            <div className="w-full">
              <p className="mb-1 text-text text-sm">CI o RIF</p>
              <div className="flex items-center border border-gray6 bg-white h-10 w-full rounded-full overflow-hidden">
                {/* <select
                  className="h-full bg-transparent outline-none text-sm px-4 border-r border-gray6"
                  value={form?.driver?.person?.document_type || ''}
                  onChange={() => {}}
                  disabled
                >
                  <option value=""></option>
                  {selects.documentTypes.map(dt => (
                    <option key={dt.value} value={dt.value}>{dt.label}</option>
                  ))}
                </select> */}
                <input
                  type="text"
                  className="flex-1 w-full h-full outline-none border-none bg-transparent px-4 text-sm"
                  value={form?.driver?.person?.document || ''}
                  onChange={() => {}}
                  disabled
                />
              </div>
            </div>

            <button
              className="h-10 bg-black text-sm text-white font-semibold px-4 py-1 rounded-full"
              onClick={() => {
                onChange('driver_id', null);
                onChange('driver', null);
                onChange('vehicle_id', null);
                onChange('vehicle', null);
              }}
            >
              Limpiar
            </button>
          </div>

          <Input
            label="Vehículo asignado"
            className={{ base: 'col-span-2' }}
            value={form.vehicle?.vehicle_types?.at(0)?.name || ''}
            onValueChange={() => {}}
            disabled
          />

          <div className="col-span-2 flex justify-between items-end gap-2">
            {isEditingVehicle ? (
              <>
                <div className="col-span-2">
                  <p className="mb-1 text-text">Placa</p>
                  <SelectVehicle
                    value={form.vehicle_id}
                    selectedLabel={form?.vehicle?.plaque}
                    onSelect={item => {
                      onChange('vehicle_id', item?.id);
                      onChange('vehicle', item);
                    }}
                  />
                </div>

                <button
                  className="h-10 text-sm text-[#396AFF] font-semibold px-4 py-1 flex justify-center items-center gap-2"
                  onClick={() => setIsEditingVehicle(false)}
                >
                  <img src={DoneIcon} className="w-4 h-4" alt="" />
                  <span>Listo</span>
                </button>
              </>
            ) : (
              <>
                <Input
                  label="Placa"
                  className={{ base: 'w-full' }}
                  value={form.vehicle?.plaque || ''}
                  onValueChange={() => {}}
                  disabled
                />
                <button
                  className="h-10 text-sm text-[#396AFF] font-semibold px-4 py-1"
                  onClick={() => setIsEditingVehicle(true)}
                >
                  Editar
                </button>
              </>
            )}
          </div>
        </div>
      )}

      <div className="flex justify-center mt-2 px-6 py-4 gap-3">
        <button
          type="button"
          className="px-6 py-2 bg-gray-200 text-text font-semibold rounded-full hover:bg-gray-300 transition-colors text-sm"
          onClick={onClose}
          disabled={isLoading}
        >
          Cerrar
        </button>
        <button
          type="button"
          className="px-6 py-2 bg-red text-white font-semibold rounded-full hover:bg-gray-800 transition-colors text-sm disabled:opacity-50"
          onClick={nextStep}
          disabled={isLoading}
        >
          {step === STEP.PERSONS
            ? 'Siguiente'
            : (isLoading ? 'Guardando...' : 'Guardar') }
        </button>
      </div>
    </div>
  );
};

const useForm = ({ initialData, onClose, onSuccess }) => {
  const getInitial = (data) => ({
    user_id: '',
    user: null,
    document_type: '',
    document: '',
    date: '',
    time: '',
    name: '',
    phone: '',
    passenger: {
      name: '',
      phone: '',
    },
    route_id: '',
    driver_id: '',
    driver: null,
    vehicle: null,
    vehicle_type: '',
    plaque: '',
  });

  const [step, setStep] = useState(STEP.PERSONS);
  const [form, setForm] = useState(getInitial(initialData));
  const [selects, setSelects] = useState({
    documentTypes: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isEditingVehicle, setIsEditingVehicle] = useState(false);

  const getSelects = async () => {
    try {
      const response = await GeneralService.getDocumentTypes();
      setSelects({
        documentTypes: response,
      });

    } catch (error) {
      console.log(error)
    }
  };

  const onChange = (target, value) => {
    if (String(target).includes('.')) {
      const [object, key] = target.split('.');
      setForm(s => ({ ...s, [object]: { ...s[object], [key]: value } }));
    } else {
      setForm(s => ({ ...s, [target]: value }));
    }
  };

  const nextStep = () => {
    if (!isValidForm()) return;

    if (step === STEP.PERSONS) return setStep(STEP.ADDRESS);
    if (step === STEP.ADDRESS) return submit();
  };

  const isValidForm = () => {
    const onError = (msg) => {
      toast.error(msg);
      return false;
    }

    if (step === STEP.PERSONS) {
      if (!form.user_id)
        return onError('Debe indicar el cliente');

      if (!form.date)
        return onError('Debe indicar la fecha');

      if (!form.time)
        return onError('Debe indicar la hora');

      if (!form.name)
        return onError('Debe indicar el nombre de la persona de contacto');

      if (!form.phone)
        return onError('Debe indicar el teléfono de la persona de contacto');

      if (!form.passenger.name && !!form.passenger.phone)
        return onError('Debe indicar el nombre de la segunda persona');
    }

    if (step === STEP.ADDRESS) {
      if (!form.route_id)
        return onError('Debe indicar la ruta');

      if (!form.driver_id)
        return onError('Debe indicar el conductor');

      if (!form.vehicle_id)
        return onError('Debe indicar el vehículo');
    }

    return true;
  };

  const submit = async () => {
    setIsLoading(true);

    try {
      const payload = {
        ...form,
        passenger: JSON.stringify(form.passenger),
        driver: undefined,
        user: undefined,
        route: undefined,
        vehicle: undefined,
      };

      await OrdersService.moderator.create(payload);
      toast.success('Ruta creada con éxito');
      onSuccess?.();
      onClose?.();

    } catch (error) {
      console.log(error)
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getSelects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    form,
    isLoading,
    isEditingVehicle,
    nextStep,
    onChange,
    selects,
    setIsEditingVehicle,
    setStep,
    step,
    submit,
  };
};

export default ModalCreateOrder;
